var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlarmBell = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#alarm-bell_svg__a)",
  fill: "#98A4AF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.864 17.722H8.137a.209.209 0 0 0-.207.185 2.083 2.083 0 1 0 4.14 0 .206.206 0 0 0-.206-.185ZM17.872 16.286a13.638 13.638 0 0 1-1.456-6.11v-.64a7.596 7.596 0 0 0-3.221-6.352 5.315 5.315 0 0 0-1.945-.765v-.947a1.25 1.25 0 0 0-2.5 0v.958a5.615 5.615 0 0 0-2.376 1.064 7.667 7.667 0 0 0-2.79 6.042v.64a13.639 13.639 0 0 1-1.456 6.11.417.417 0 0 0 .372.603h15a.416.416 0 0 0 .372-.604Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "alarm-bell_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .222)",
  d: "M0 0h20v20H0z"
})))));
export { SvgAlarmBell as ReactComponent };
export default __webpack_public_path__ + "319bd15a54f4e38f1e3c4bc57cbda2ea.svg";